import React, { useContext } from 'react';
import styled from '@emotion/styled';

import { DispatchContext } from '@store/store';
import { openAuthModal } from '@store/actions';

const WorkFlowItem = ({
  imageSrc,
  imageAlt,
  route,
  routeTitle,
  routeDetail,
}) => {
  const dispatch = useContext(DispatchContext);
  const redirectToTemplates = (workflow = 'story') => {
    if (window.innerWidth > 768) {
      let url = '';
      if (workflow == 'story') {
        url = '/templates/storyteller?dimension=16:9';
      } else if (workflow == 'scratch') {
        url = '/templates/marketing/10456?dimension=16:9';
      } else if (workflow == 'logo-reveal') {
        url =
          '/templates/marketing/categories/Intro%20%2F%20Outro%20%5Blogo%20reveal%5D';
      } else {
        url = '/templates/marketing?dimension=16:9';
      }
      window.open(url, '_self');
    } else {
      dispatch(openAuthModal({ tab: 'signup' }));
    }
  };

  return (
    <WorkFlowItemStyled
      className="route aos-init relative aos-animate cursor-pointer w-full max-w-xs text-center flex flex-col justify-center m-3 p-4 rounded-lg border"
      onClick={redirectToTemplates}
      data-aos="fade-left"
      aria-hidden
      style={{
        minWidth: '300px',
      }}
      data-aos-duration="1000"
    >
      <span className="inner-text font-black absolute text-5xl left-0 right-0 top-4">
        {route}
      </span>
      <div className="route-icon z-10">
        <img
          loading="lazy"
          className="mx-auto mt-6"
          src={imageSrc}
          alt={imageAlt}
        />
      </div>
      <h3 className="route-type text-xl my-2">{routeTitle}</h3>
      <p
        className="route-detail text-xs"
        dangerouslySetInnerHTML={{
          __html: routeDetail,
        }}
      />
    </WorkFlowItemStyled>
  );
};

function WorkflowHome() {
  return (
    <section
      className="section workflow aos-init aos-animate"
      id="workflow"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      <div className="header-section" />
      <div className="body">
        <div className="content flex justify-center items-center flex-col">
          <div
            className="headers aos-init aos-animate text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="text-brandPrimary text-2xl md:text-4xl">
              What are we creating today?
            </h1>
            <h2 className="text-lg my-2" style={{ color: '#7a7cbb' }}>
              Get tailored template recommendations
            </h2>
          </div>

          <div className="content-wrapper flex flex-col md:flex-row justify-center items-center md:justify-between md:items-end">
            <WorkFlowItem
              imageSrc="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/blog.svg"
              imageAlt="blog"
              route="blog"
              routeTitle="Article-to-Video"
              routeDetail="Convert your article to an <br /> engaging video"
            />
            <WorkFlowItem
              imageSrc="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/www.svg"
              imageAlt="www"
              route="www"
              routeTitle="URL-to-Video"
              routeDetail="Make a video with just the URL
              <br />
              of your article"
            />
            <WorkFlowItem
              imageSrc="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/ready.svg"
              imageAlt="ready"
              route="ready"
              routeTitle="Pre-made Templates"
              routeDetail="Find &amp; customize templates for
              <br />
              anything and everything."
            />
          </div>

          <div className="content-wrapper flex flex-col md:flex-row justify-center items-center md:justify-between md:items-end">
            <WorkFlowItem
              imageSrc="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/logo.svg"
              imageAlt="logo"
              route="logo"
              routeTitle="Logo Revealers"
              routeDetail="Give your logo an
              <br />
              exciting launch"
            />
            <WorkFlowItem
              imageSrc="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/upload.svg"
              imageAlt="upload"
              route="upload"
              routeTitle="Media-First Videos"
              routeDetail="Create your videos with just
              <br /> your media"
            />
            <WorkFlowItem
              imageSrc="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/blank.svg"
              imageAlt="blank"
              route="blank"
              routeTitle="Blank Canvas"
              routeDetail="Do your thing"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WorkflowHome;

const WorkFlowItemStyled = styled.div`
  transition: all 0.2s ease;
  min-height: 200px;

  .inner-text {
    height: 57px;
    font-size: 57px;
    letter-spacing: 2px;
    color: #ebf2fa;
    z-index: -1;
  }

  &:hover {
    background-color: #ebf2fa;

    .inner-text {
      z-index: 0;
      color: #fff;
    }
  }
`;
